import { useEffect, useRef } from 'react';

/**
 * Astryx TextInput deliberately omits `inputMode`/`enterKeyHint` from its
 * props; mobile keyboards still need them. Apply them to the rendered input.
 */
export function useInputAttrs<T extends HTMLElement>(attrs: Record<string, string>) {
  const ref = useRef<T | null>(null);
  const serialized = JSON.stringify(attrs);
  useEffect(() => {
    const input = ref.current?.querySelector('input, textarea');
    if (!input) return;
    for (const [k, v] of Object.entries(JSON.parse(serialized) as Record<string, string>)) input.setAttribute(k, v);
  }, [serialized]);
  return ref;
}
